import { useQuery } from '@tanstack/react-query';

import { fetchReferencedPosts, type ReferencedPostsParams } from '../api';

export const useFetchReferencedPosts = (params: ReferencedPostsParams, enabled: boolean) => {
  const { session_id, block_id, answer_id, parts, part_id, limit, order } = params;
  return useQuery({
    queryKey: ['referenced-posts', session_id, block_id, answer_id, parts, part_id, limit, order],
    queryFn: ({ signal }) => fetchReferencedPosts(params, signal),
    enabled: enabled,
  });
};
